import {
  CRM_BOOKS_COMPANY_QUERY_KEY,
  CRM_PAGE,
  CrmPage,
} from "constants/crmPages";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { Group } from "types/Models/group";

export const useCrmTabs = (data: Group | null): CrmPage[] => {
  const { uuid: groupId, has_books_access_to_fca } = useCurrentGroupContext();
  const {
    isAdmin,
    isCpa,
    isForeignCA,
    isUserTypeForeignCA,
    canManageInternalTickets,
  } = useRoleBasedView();
  const isFCA = isUserTypeForeignCA || isForeignCA;

  const internalTeam = isAdmin ? [CRM_PAGE.INTERNAL_TEAM_SETTINGS] : [];

  const companyTickets = canManageInternalTickets ? [CRM_PAGE.TICKETS] : [];

  const booksTab =
    (isForeignCA && has_books_access_to_fca) || !isForeignCA
      ? [
          {
            ...CRM_PAGE.BOOKS,
            url: `${CRM_PAGE.BOOKS.url}?${CRM_BOOKS_COMPANY_QUERY_KEY}=${groupId}`,
          },
        ]
      : [];

  const salesTaxTab = {
    ...CRM_PAGE.SALES_TAX,
    url: `${CRM_PAGE.SALES_TAX.url}?${CRM_BOOKS_COMPANY_QUERY_KEY}=${groupId}`,
  };

  const billing = isAdmin || isCpa || isForeignCA ? [CRM_PAGE.BILLING] : [];

  const AccountInfo = !isFCA ? [CRM_PAGE.ACCOUNT_INFO] : [];

  const StateIncomeTax = !isFCA ? [CRM_PAGE.STATE_INCOME_TAX] : [];

  let crmTabs: CrmPage[] = [
    CRM_PAGE.ENTITIES,
    CRM_PAGE.HOME,
    ...AccountInfo,
    CRM_PAGE.FILINGS,
    ...booksTab,
    ...companyTickets,
    CRM_PAGE.CHAT,
    {
      ...CRM_PAGE.DOCUMENTS,
      url: `${CRM_PAGE.DOCUMENTS.url}/${data?.documents_group_id}`,
    },
    CRM_PAGE.TEAM_SETTINGS,
    ...billing,
    ...internalTeam,
    CRM_PAGE.ESTIMATED_TAX,
    ...StateIncomeTax,
    CRM_PAGE.ACTION_CENTRE,
    CRM_PAGE.AUTO_FILL,
    CRM_PAGE.STATE_COMPLIANCE,
    salesTaxTab,
  ];

  if (isAdmin) {
    crmTabs = [...crmTabs, CRM_PAGE.RA, CRM_PAGE.MAILROOM];
  }

  if (isFCA) {
    crmTabs = [
      ...crmTabs.filter(
        (tab) =>
          !tab.url.startsWith(CRM_PAGE.STATE_COMPLIANCE.url) &&
          !tab.url.startsWith(CRM_PAGE.ESTIMATED_TAX.url)
      ),
      CRM_PAGE.STATE_COMPLIANCE,
      CRM_PAGE.ESTIMATED_TAX,
      CRM_PAGE.RA,
      CRM_PAGE.MAILROOM,
    ];
  }

  if (isAdmin) {
    crmTabs = [...crmTabs, CRM_PAGE.PERKS, CRM_PAGE.AUDIT_LOGS];
  }

  return crmTabs;
};
